import { Icon } from '../../components/Icon';
import type { TradingEnv } from '../../routes/types';
import { LIVE_FILL } from './liveStyles';

/** Which deployment this is, from the host: the badge always says where you are. */
export function deploymentLabel(hostname: string): string {
  if (hostname === 'gi-trader.appstack.ch') return 'production';
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '') return 'dev';
  return hostname;
}

/**
 * The environment badge: paper (blue) or LIVE (crimson, icon, spelled out). Always in the
 * top bar, which never scrolls away. The Live state is structural — icon and words — so a
 * colour-deficient reader can tell it from a status tag at a glance.
 */
export function EnvBadge({
  env,
  deployment,
  compact = false,
}: {
  env: TradingEnv;
  deployment: string;
  compact?: boolean;
}) {
  if (env === 'live') {
    return (
      <span
        data-env-badge="live"
        title={`LIVE trading — real money · ${deployment}`}
        className={`inline-flex h-[25px] items-center gap-1.5 rounded-full px-2.5 text-[11.5px] font-bold tracking-wide whitespace-nowrap ${LIVE_FILL}`}
      >
        <Icon name="alert" size={13} />
        LIVE{compact ? '' : ` · real money · ${deployment}`}
      </span>
    );
  }
  return (
    <span
      data-env-badge="paper"
      title={`Paper trading · ${deployment}`}
      className="inline-flex h-[25px] items-center gap-1.5 rounded-full bg-paper-soft px-2.5 text-[11.5px] font-semibold whitespace-nowrap text-paper"
    >
      <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />
      {compact ? 'PAPER' : `Paper · ${deployment}`}
    </span>
  );
}
